import styled from "@emotion/styled";
import { EmptySpace } from "@src/component/SignComponent";

export const Section3 = () => (
	<Wrapper>
		<div className="help">
			문의사항은 담당 매칭 컨설턴트 또는{" "}
			<a href="https://1point.channel.io/home" target="blank">
				여기를 클릭해
			</a>{" "}
			주세요
			<EmptySpace space={20} />
		</div>
	</Wrapper>
);

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: var(--card-bg);

	max-width: 80%;
	text-align: center;

	.title {
		font-size: 24px;
		font-weight: 800;
	}

	.sub-title {
		font-size: 16px;
		font-weight: 400;
		white-space: pre-wrap;
	}

	.help {
		font-size: 15px;
		a {
			text-decoration: underline;
			color: var(--primary);
		}
	}

	.btn {
		border-radius: 30px;
		border: 2px solid var(--primary);
		background-color: transparent;
		font-size: 20px;
		font-weight: 700;
		max-width: 450px;
		width: 100%;
		padding: 10px;

		@media screen and (max-width: 768px) {
			font-size: 16px;
		}
	}
`;
